import { isValidPhoneNumber } from 'libphonenumber-js';
import type { EscalationRule, PhoneTree } from '../types';

export function validateDefaultPhone(
  value: string | undefined,
  rulesCount: number,
  menu?: PhoneTree
): Promise<void> {
  const v = String(value || '').trim();
  if (!v) {
    const needsDefault = menu?.enabled
      ? menu.options.some((option) => option.destination === 'default')
      : rulesCount > 0;
    return needsDefault
      ? Promise.reject(new Error('Please enter a phone number'))
      : Promise.resolve();
  }
  try {
    if (!isValidPhoneNumber(v))
      return Promise.reject(new Error('Invalid phone number'));
  } catch {
    return Promise.reject(new Error('Invalid phone number'));
  }
  const digits = v.replace(/[^\d]/g, '');
  if ((digits.startsWith('1') || v.startsWith('+1')) && digits.includes('555'))
    return Promise.reject(new Error('Please enter a real phone number'));
  return Promise.resolve();
}

export function validateEscalationRules(
  value: EscalationRule[] | null,
  isDefaultAgent: boolean,
  menu?: PhoneTree
): Promise<void> {
  if (!Array.isArray(value) || value.length === 0) return Promise.resolve();
  for (const rule of value) {
    const phone = String(rule.phone_number || '').trim();
    if (!phone)
      return Promise.reject(
        new Error('All escalation rules require a phone number')
      );
    try {
      if (!isValidPhoneNumber(phone))
        return Promise.reject(
          new Error('All escalation rules require a valid phone number')
        );
    } catch {
      return Promise.reject(
        new Error('All escalation rules require a valid phone number')
      );
    }
    if (
      !isDefaultAgent &&
      !menu?.options?.some((option) => option.destination === rule.id) &&
      (!rule.escalate_when || rule.escalate_when.length === 0)
    )
      return Promise.reject(
        new Error(
          'All escalation rules require at least one escalation trigger'
        )
      );
  }
  return Promise.resolve();
}
